import {
  CreditCardOutlined,
  MobileOutlined,
  BankOutlined,
  WalletOutlined,
} from '@ant-design/icons';

// Payment Mode Options
export const PAYMENT_MODE_OPTIONS = [
  { label: 'Cash', value: 'CASH' },
  { label: 'Gpay', value: 'GPAY' },
] as const;

// Payment Mode Colors
export const PAYMENT_MODE_COLORS = {
  CASH: 'green',
  GPAY: 'blue',
} as const;

// Payment Mode Icons
export const PAYMENT_MODE_ICONS = {
  CASH: <WalletOutlined />,
  GPAY: <MobileOutlined />,
} as const;
